import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ae97a754")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createBlock(_component_Dropdown, {
    modelValue: _ctx.selected,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selected = $event)),
    options: _ctx.options,
    optionLabel: "LABEL",
    optionValue: "ID",
    placeholder: _ctx.$t('choose_dropdown'),
    filter: _ctx.filter,
    filterPlaceholder: _ctx.$t('search'),
    class: "p-mb-2",
    showClear: _ctx.clearable,
    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.select($event.value)))
  }, null, 8, ["modelValue", "options", "placeholder", "filter", "filterPlaceholder", "showClear"]))
})